import { OmitId } from 'types';
import { ILanguage } from 'types/languageEntity';
import { convertLanguageLevelToPortuguese } from './convertLanguageLevelToPortuguese';

export const convertLanguageFromObjectToString = (
  { name, level }: OmitId<ILanguage>,
  separator = ', ',
): string => `${name}${separator}${convertLanguageLevelToPortuguese(level)}`;
